import React from 'react';
import PropTypes from 'prop-types';
import DefaultHeader from '../AppHeader';
import style from './style.css';
import BlueBg from '../../../../../images/pageStyles/BlueBG.svg';

export default class Topo extends React.Component {
    static propTypes = {
        header: PropTypes.node,
        footer: PropTypes.node,
        showHeader: PropTypes.bool,
        showFooter: PropTypes.bool,
        children: PropTypes.node,
    };

    static thumbnail = BlueBg;

    render() {
        const { showHeader, showFooter, footer } = this.props;
        const header = this.props.header || <DefaultHeader />;

        return (
            <div className={style.wrapper} style={{ backgroundImage: `url(${BlueBg})` }}>
                {showHeader && <div>{header}</div>}
                <div className={style.body}>
                    <div className="container">{this.props.children}</div>
                </div>
                {showFooter && footer && <div>{footer}</div>}
            </div>
        );
    }
}
